import React, { useContext, useState } from 'react';
import { Button } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { AppContext } from '../App/appReducer';
import { AppActionKind, AppPageKind } from '../App/types';
import isBuilding from './jsonSchemaUtilities/isBuilding';
import {
  WorkflowEngineContext,
  WorkflowEngineMode
} from '../WorkflowEngine/workflowEngineReducer';
import UnsavedChangesWarningDialog from '../WorkflowEngine/UnsavedChangesWarningDialog';

export default () => {
  const { dispatch } = useContext(AppContext);
  const { state: WorkflowState } = useContext(WorkflowEngineContext);
  const { pages, isReadOnlyView, mode } = WorkflowState;

  const [openUnsavedChangesWarningDialog, setOpenUnsavedChangesWarningDialog] =
    useState(false);

  const switchToLandingPage = () => {
    dispatch({
      type: AppActionKind.SET_APPPAGE,
      payload: AppPageKind.LANDING
    });
  };

  const handleBackButton = (event: React.SyntheticEvent) => {
    if (isBuilding(pages) && !isReadOnlyView) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    if (
      mode === WorkflowEngineMode.MAPPER &&
      window.GrapeCity?.ActiveReports.WebDesigner.api.isReportDirty()
    ) {
      setOpenUnsavedChangesWarningDialog(true);
      return;
    }

    switchToLandingPage();
  };

  return (
    <>
      <Button
        variant="text"
        onClick={handleBackButton}
        startIcon={<ArrowBackIosIcon fontSize="small" />}
      >
        Back
      </Button>
      <UnsavedChangesWarningDialog
        open={openUnsavedChangesWarningDialog}
        selectedTab={WorkflowEngineMode.BUILD}
        handleClose={() => setOpenUnsavedChangesWarningDialog(false)}
        handleOk={switchToLandingPage}
      />
    </>
  );
};
